"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlexContainer = void 0;
var react_1 = __importDefault(require("react"));
exports.FlexContainer = function (props) {
    var style = {
        display: 'flex',
        flexDirection: 'row',
    };
    var children = props.children, rest = __rest(props, ["children"]);
    if (props.width)
        style.width = props.width;
    if (props.height)
        style.height = props.height;
    if (props.inlineFlex)
        style.display = 'inline-flex';
    if (props.direction)
        style.flexDirection = props.direction;
    if (props.wrap)
        style.flexWrap = props.wrap;
    if (props.justifyContent)
        style.justifyContent = props.justifyContent;
    if (props.alignItems)
        style.alignItems = props.alignItems;
    if (props.alignContent)
        style.alignContent = props.alignContent;
    return (react_1.default.createElement("div", __assign({ style: style }, rest), children));
};
//# sourceMappingURL=FlexContainer.js.map